import {
    GETGATEWAYACCOUNT_SUCCESS,
    GETGATEWAYACCOUNT_FAILED,
    RESET_GETGATEWAYACCOUNT,
    LOADING_GETGATEWAYACCOUNT,
    NETWORK_ERROR_GETGATEWAYACCOUNT
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETGATEWAYACCOUNT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETGATEWAYACCOUNT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETGATEWAYACCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETGATEWAYACCOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETGATEWAYACCOUNT:
            return (state = initialState);
        default:
            return state;
    }
};
